<template>
  <div class="cost-calculation">
    <div class="content">
      <div class="left">
        <div class="title">客户快递计算</div>
        <div class="throw-rule">
          <span>客户列表：</span>
          <p class="input-container">
            <el-select class="gray" v-model="clientObj.clientId" filterable>
              <el-option
                v-for="item in clientList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </p>
        </div>
        <div class="throw-rule">
          <span>快递类型：</span>
          <p class="input-container">
            <el-select class="gray" v-model="clientObj.expressId">
              <el-option
                v-for="item in expressTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </p>
        </div>
        <div class="throw-rule">
          <span>目的地：</span>
          <p class="input-container">
            <el-input v-model="clientObj.address" class="gray white"></el-input>
          </p>
        </div>
        <div class="throw-rule">
          <span>重量：</span>
          <p class="input-container">
            <el-input
              v-model="clientObj.weight"
              @input="inputPriceLimit(clientObj.weight, 'clientObj')"
              class="gray white"
            ></el-input>
          </p>
        </div>
        <el-button @click="clientCalculation" class="btn-blue">计算</el-button>
        <div class="throw-rule cost">
          <span>客户费用：</span>
          <p class="input-container">{{ clientObj.clientCost }} 元</p>
        </div>
      </div>
      <div class="right">
        <div class="title">承运商快递计算</div>
        <div class="throw-rule">
          <span>仓库：</span>
          <p class="input-container">
            <el-select class="gray" v-model="logisticObj.warehouseId">
              <el-option
                v-for="item in warehouseList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </p>
        </div>
        <div class="throw-rule">
          <span>快递类型：</span>
          <p class="input-container">
            <el-select class="gray" v-model="logisticObj.expressId">
              <el-option
                v-for="item in expressTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </p>
        </div>
        <div class="throw-rule">
          <span>目的地：</span>
          <p class="input-container">
            <el-input
              v-model="logisticObj.address"
              class="gray white"
            ></el-input>
          </p>
        </div>
        <div class="throw-rule">
          <span>重量：</span>
          <p class="input-container">
            <el-input
              v-model="logisticObj.weight"
              @input="inputPriceLimit(logisticObj.weight, 'logisticObj')"
              class="gray white"
            ></el-input>
          </p>
        </div>
        <el-button @click="logisticsCalculation" class="btn-blue"
          >计算</el-button
        >
        <div class="throw-rule cost">
          <span>承运商费用：</span>
          <p class="input-container">{{ logisticObj.logisticCost }} 元</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Logistics from "models/logistics";
import Expenses from "models/expenses";
import Calculation from "models/cost-calculation";
const expenses = new Expenses();
const logistics = new Logistics();
export default {
  data() {
    return {
      clientObj: {
        clientId: "",
        expressId: "",
        address: "",
        weight: "",
        clientCost: "",
      },
      logisticObj: {
        warehouseId: "",
        expressId: "",
        address: "",
        weight: "",
        logisticCost: "",
      },
      clientList: [],
      expressTypeList: [],
      warehouseList: [],
    };
  },

  created() {
    this.getClientList();
    this.getExpressTypeList();
    this.getWarehouse();
  },

  methods: {
    clientCalculation() {
      let customerId = this.clientObj.clientId;
      let carrierId = this.clientObj.expressId;
      let address = this.clientObj.address;
      let weight = this.clientObj.weight;
      Calculation.getClientCostCalculation(
        customerId,
        carrierId,
        address,
        weight
      ).then((res) => {
        if (res.success) {
          this.clientObj.clientCost = res.result
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    logisticsCalculation() {
      let warehouseId = this.logisticObj.warehouseId;
      let carrierId = this.logisticObj.expressId;
      let address = this.logisticObj.address;
      let weight = this.logisticObj.weight;
      Calculation.getLogisticObjCostCalculation(
        warehouseId,
        carrierId,
        address,
        weight
      ).then((res) => {
        if (res.success) {
          this.logisticObj.logisticCost = res.result
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    /* 限制小数点后两位 */
    inputPriceLimit(val, type) {
      if (val == ".") {
        val = "";
      }
      let numLimit = val.toString().match(/^\d*(\.?\d{0,2})/g)
        ? val === "00"
          ? "0"
          : val.toString().match(/^\d*(\.?\d{0,2})/g)[0]
        : "";
      if (type === "clientObj") {
        this.clientObj.weight = numLimit;
      } else {
        this.logisticObj.weight = numLimit;
      }
    },
    /* 获取客户列表 */
    getClientList() {
      logistics.getCustomerData().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.ordersName;
            arr.push(obj);
          });
          this.clientList = arr;
        }
      });
    },
    /* 获取快递列表 */
    getExpressTypeList() {
      logistics.getExpressData().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.expressTypeList = arr;
        }
      });
    },
    //获取仓库数据
    getWarehouse() {
      expenses.getWarehouseData().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.warehouseList = arr;
        }
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.cost-calculation {
  flex: 1;
  background: #fff;
  .content {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-radius: 8px;
    padding: 0px 20px;
    .left,
    .right {
      width: 50%;
    }
    .title {
      height: 56px;
      font-size: 16px;
      color: #999999;
      font-weight: 400;
      line-height: 56px;
      background: #ffffff;
    }
    .throw-rule {
      height: 32px;
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      font-size: 14px;
      color: #666;
      > span {
        width: 100px;
        text-align: right;
      }
      .input-container {
        position: relative;
        color: #999999;
        width: 200px;
      }
    }
    .cost {
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      .input-container {
        font-size: 16px;
        font-weight: 400;
        color: #333333;
      }
    }
    .btn-blue {
      margin-left: 100px;
      margin-bottom: 16px;
    }
  }
}
</style>
<style lang="scss">
.cost-calculation {
  .throw-rule {
    .el-select {
      width: 200px;
    }
  }
}
</style>
